import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { store } from '../../domain/users/store';
import { LocalStorage_keys, Public_Routes } from '../../main/constants';
import ssoClient from './ssoClient';
import { manageTokenService } from '../services/manageTokenService';

const apiAgentInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const requestWithTokenInterceptor = (config: AxiosRequestConfig) => {
    const token = store.commonStore.token;
    const locale = localStorage.getItem('lang');

    if (token) config!.headers!.Authorization = `Bearer ${token}`;
    if (locale) config!.headers!.Locale = locale;

    return config;
};

apiAgentInstance.interceptors.request.use(requestWithTokenInterceptor);

apiAgentInstance.interceptors.response.use(
    (response) => {
        const isTokenSoonToExpire = manageTokenService.isTokenAboutToExpire(
            localStorage.getItem(LocalStorage_keys.JWT_KEY)
        );

        if (isTokenSoonToExpire) {
            ssoClient.getMe().then((response) => {
                localStorage.setItem(
                    LocalStorage_keys.JWT_KEY,
                    JSON.stringify(response.token)
                );
                localStorage.setItem(
                    LocalStorage_keys.USER_KEY,
                    JSON.stringify(response.user)
                );
            });
        }

        return response;
    },
    (error) => {
        const existToken = localStorage.getItem(LocalStorage_keys.JWT_KEY);

        if (error?.response?.status === 401 && existToken !== null) {
            toast.error(
                'Su sesión ha expirado, será redirigido al inicio de sesión.',
                {
                    autoClose: 4000,
                    position: toast.POSITION.TOP_CENTER,
                }
            );

            setTimeout(function () {
                window.document.location = Public_Routes.LOGIN;
            }, 4100);

            localStorage.removeItem(LocalStorage_keys.JWT_KEY);
        }
        return Promise.reject(error);
    }
);

const responseBody = (response: AxiosResponse) => response.data;

const httpClient = {
    post: (url: string, body: {}): Promise<any> => {
        return apiAgentInstance.post(url, body).then(responseBody);
    },
    postWithParameters: (url: string, body: {}, parameters: {}): Promise<any> => {
        return apiAgentInstance.post(url, body, parameters).then(responseBody);
    },
    put: (url: string, body: {}): Promise<any> => {
        return apiAgentInstance.put(url, body).then(responseBody);
    },
    putEmpty: (url: string): Promise<any> => {
        return apiAgentInstance.put(url).then(responseBody);
    },
    delete: (url: string): Promise<any> => {
        return apiAgentInstance.delete(url).then(responseBody);
    },
    deleteWithBody: (url: string, body: {}): Promise<any> => {
        return apiAgentInstance.delete(url, body).then(responseBody);
    },
    get: (url: string): Promise<any> => {
        return apiAgentInstance.get(url).then(responseBody);
    },
    patch: (url: string, body: {}): Promise<any> => {
        return apiAgentInstance.patch(url, body).then(responseBody);
    }
};

export default httpClient;
